import { LOCAL_STORAGE_UTM_TAGS_KEY } from 'shared/consts';

export type UtmTags = {
  utmSource?: string;
  utmMedium?: string;
  utmCampaign?: string;
  utmTerm?: string;
  utmContent?: string;
};

const UTM_PARAM_TO_FIELD: Record<string, keyof UtmTags> = {
  utm_source: 'utmSource',
  utm_medium: 'utmMedium',
  utm_campaign: 'utmCampaign',
  utm_term: 'utmTerm',
  utm_content: 'utmContent',
};

const hasUtmTags = (utmTags: UtmTags) => Object.values(utmTags).some(Boolean);

export const captureUtmTags = (search: string) => {
  const params = new URLSearchParams(search);
  const utmTags = Object.entries(UTM_PARAM_TO_FIELD).reduce<UtmTags>(
    (result, [paramName, fieldName]) => {
      const value = params.get(paramName);

      if (value) {
        result[fieldName] = value;
      }

      return result;
    },
    {}
  );

  if (hasUtmTags(utmTags)) {
    localStorage.setItem(LOCAL_STORAGE_UTM_TAGS_KEY, JSON.stringify(utmTags));
  }
};

export const getStoredUtmTags = (): UtmTags => {
  const storedTags = localStorage.getItem(LOCAL_STORAGE_UTM_TAGS_KEY);

  if (!storedTags) {
    return {};
  }

  try {
    return JSON.parse(storedTags);
  } catch {
    return {};
  }
};

export const clearStoredUtmTags = () => {
  localStorage.removeItem(LOCAL_STORAGE_UTM_TAGS_KEY);
};
